import React, { useEffect, useState } from "react";
import { Nav, Tab } from "react-bootstrap";
import Constants from "../../../Variables/Constants";
import axios from "axios";
import { toast } from "react-toastify";
import "../css/MainFabric.css";

const MainFabric = ({
  setMainFabricId,
  setBgColor,
  setFabricImage,
  canvasWidth,
  canvasHeight,
  setFabricData,
  fabricData,
  selectedSize,
  onFabricSelect,
  mainFabricList,
  activeTabState,
  setActiveTabState,
  setSelectedTabData,
  selectedTabData,
  captureSnapshot
}) => {
  const [hoveredItem, setHoveredItem] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredFabricList, setFilteredFabricList] = useState({});
  const [pinnedItems, setPinnedItems] = useState([]);

  const itemsPerPage = 4;
  const keys = Object.keys(searchTerm ? filteredFabricList : mainFabricList);
  const [startIndex, setStartIndex] = useState(0);

  const handlePinToggle = (item) => {
    const isCurrentlyPinned = isPinned(item._id);

    setPinnedItems(prevPinned => {
      if (isCurrentlyPinned) {
        // Unpin the item
        return prevPinned.filter(pinnedItem => pinnedItem._id !== item._id);
      } else {
        // Pin the item - add to end so it appears first when sorted
        return [...prevPinned, item];
      }
    });
  };

  // Check if item is pinned
  const isPinned = (itemId) => {
    return pinnedItems.some(pinnedItem => pinnedItem._id === itemId);
  };

  // Sort data to show pinned items first (latest pinned item first)
  const getSortedData = (data) => {
    if (!data || data.length === 0) return [];

    const unpinnedInCategory = data.filter(item => !isPinned(item._id));

    // Get pinned items in reverse order of pinning (latest pinned first)
    const pinnedInCategory = [];

    // Loop through pinnedItems array in reverse to get latest pinned first
    for (let i = pinnedItems.length - 1; i >= 0; i--) {
      const pinnedItem = pinnedItems[i];
      // Check if this pinned item exists in current category data
      const itemInData = data.find(item => item._id === pinnedItem._id);
      if (itemInData) {
        pinnedInCategory.push(itemInData);
      }
    }

    // Return latest pinned items first, then unpinned items
    return [...pinnedInCategory, ...unpinnedInCategory];
  };

  // Update selected tab data
  const updateSelectedTabData = () => {
    const dataSource = searchTerm ? filteredFabricList : mainFabricList;
    const rawData = dataSource[activeTabState] || [];
    const sortedData = getSortedData(rawData);
    setSelectedTabData(sortedData);
  };

  // Search functionality
  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchTerm(value);

    if (value === "") {
      setFilteredFabricList({});
      const rawData = mainFabricList[activeTabState] || [];
      setSelectedTabData(getSortedData(rawData));
    } else {
      const filtered = {};

      // Filter through each category
      Object.keys(mainFabricList).forEach(category => {
        const filteredItems = mainFabricList[category].filter(item =>
          item.name.toLowerCase().includes(value)
        );

        if (filteredItems.length > 0) {
          filtered[category] = filteredItems;
        }
      });

      setFilteredFabricList(filtered);

      // Update selected tab data based on current active tab
      if (filtered[activeTabState]) {
        setSelectedTabData(getSortedData(filtered[activeTabState]));
      } else {
        // If current tab has no results, switch to first available tab
        const firstAvailableTab = Object.keys(filtered)[0];
        if (firstAvailableTab) {
          setActiveTabState(firstAvailableTab);
          setSelectedTabData(getSortedData(filtered[firstAvailableTab]));
        } else {
          setSelectedTabData([]);
        }
      }
    }
  };

  // Update selected tab data when tab changes
  const handleTabChange = (tabName) => {
    console.log("Tab changed to:", tabName);
    setActiveTabState(tabName);
    const dataSource = searchTerm ? filteredFabricList : mainFabricList;
    const rawData = dataSource[tabName] || [];
    const sortedData = getSortedData(rawData);
    setSelectedTabData(sortedData);
    console.log("Tab data set immediately:", sortedData.length, "items");
  };

  const handleNext = () => {
    if (startIndex + itemsPerPage < keys.length) {
      setStartIndex(startIndex + 1);
    }
  };

  const handlePrev = () => {
    if (startIndex > 0) {
      setStartIndex(startIndex - 1);
    }
  };

  const getFabric = (e, main_fabric_id) => {
    setMainFabricId(main_fabric_id);
    setBgColor("white");
    const img = new window.Image();
    img.crossOrigin = "Anonymous";
    img.src = e;

    img.onload = () => {
      setFabricImage((prevImages) => [
        {
          id: `imagess-${prevImages.length}`,
          image: img,
          x: 0,
          y: 0,
          width: canvasWidth,
          height: canvasHeight,
        },
      ]);
    };

    img.onerror = () => {
      console.error("Image failed to load:", e);
    };
  };

 
  // Update selected tab data when pinnedItems or searchTerm changes (but NOT activeTabState)
  useEffect(() => {
    if (mainFabricList && Object.keys(mainFabricList).length > 0 && activeTabState) {
      updateSelectedTabData();
    }
  }, [pinnedItems, searchTerm, mainFabricList]);

  

  return (
    <div className="w-100">
      {/* Search Input */}
      <div className="mb-3">
        <input
          type="text"
          name="search"
          id="search-fabric"
          placeholder="Search fabrics by name..."
          value={searchTerm}
          onChange={handleSearch}
          className="form-control"
          style={{
            padding: '8px 12px',
            border: '1px solid #ddd',
            borderRadius: '4px',
            width: '100%',
            fontSize: '14px'
          }}
        />
      </div>

      <div className="tab-slider-container">
        <Nav className="nav-tabs-container">
          {keys.map((item, index) => item !== "others" && (
            <Nav.Item className="" key={index + startIndex} style={{ paddingBottom: "10px" }}>
              <Nav.Link
                eventKey={item}
                onClick={() => handleTabChange(item)}
                className={`nav-tab ${item === activeTabState ? "active-tab" : ""}`}
              >
                {item.replaceAll("_", " ")}
                {/* Show count of filtered items */}
                {searchTerm && (
                  <span className="ms-1 badge bg-secondary">
                    {(searchTerm ? filteredFabricList[item] : mainFabricList[item])?.length || 0}
                  </span>
                )}
              </Nav.Link>
            </Nav.Item>
          ))}
        </Nav>
      </div>

      {selectedTabData && selectedTabData.length > 0 && activeTabState ? (
        <>
          <Tab.Content className="tab-content" style={{ maxHeight: "780px", overflowY: "auto", display: "flex", flexWrap: "wrap", justifyContent: "center", alignItems: "center" }}>
            {selectedTabData.map((item, index) => (
              <Tab.Pane
                key={item._id}
                eventKey={activeTabState}
                active={activeTabState}
              >
                <div
                  className={`color-box pt-2 ${fabricData?._id === item?._id && "explore_our_products_card"}`}
                  style={{ position: 'relative' }}
                  onMouseEnter={() => setHoveredItem(item._id)}
                  onMouseLeave={() => setHoveredItem(null)}
                >
                  <img loading="lazy" 
                    src={Constants.imgDomain + item.image}
                    alt={`img${index + 1}`}
                    className="color-box"
                
                    onClick={() => {
                      onFabricSelect(item);
                      setFabricData(item);
                      captureSnapshot();
                      getFabric(Constants.imgDomain + item.image, item._id);
                    }}
                  />

                  {/* Tooltip for fabric name */}
                  {hoveredItem === item._id && (
                    <div
                      style={{
                        position: 'absolute',
                        top: '30px',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        backgroundColor: 'rgba(0, 0, 0, 0.8)',
                        color: 'white',
                        padding: '5px 10px',
                        borderRadius: '4px',
                        fontSize: '12px',
                        whiteSpace: 'nowrap',
                        zIndex: 10,
                        pointerEvents: 'none'
                      }}
                    >
                      {item.name || 'Fabric Name'}
                    </div>
                  )}

                  {fabricData && fabricData._id === item._id && (
                    <div
                      onClick={() => {
                        setFabricData("");
                        setMainFabricId("");
                        setBgColor(null);
                        setFabricImage([]);
                        captureSnapshot();
                      }}
                      style={{ cursor: "pointer", borderRadius: "14px" }}
                      className="position-absolute bg-xx active z-3 h-100 w-100 d-flex justify-content-center align-items-center top-0 right-0 mt-2"
                    >
                      <img loading="lazy" 
                        src="https://png.pngtree.com/png-vector/20221215/ourmid/pngtree-green-check-mark-png-image_6525691.png"
                        alt="Active"
                        
                        style={{ objectFit: "unset", width: "30px", height: "30px" }}
                        className="p-1"
                      />
                    </div>
                  )}
                </div>
              </Tab.Pane>
            ))}
          </Tab.Content>
        </>
      ) : (
        <>
          <Tab.Content className="tab-content">
            <Tab.Pane eventKey={activeTabState}>
              <div>
                {searchTerm ?
                  `No fabrics found matching "${searchTerm}" in this category.` :
                  "No fabrics available in this category."
                }
              </div>
            </Tab.Pane>
          </Tab.Content>
        </>
      )}
    </div>
  );
};

export default React.memo(MainFabric);